document.addEventListener('DOMContentLoaded', function () {
  const cartContainer = document.querySelector('main-cart');

  cartContainer.addEventListener('change', function (event) {
    const checkbox = event.target.closest('.subscribe-checkbox');
    if (!checkbox) return;

    const lineItemKey = checkbox.dataset.key;
    const sellingPlanId = parseInt(checkbox.dataset.sellingPlanId);
    const isSubscribing = checkbox.checked;

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({
      id: lineItemKey,
      quantity: 1,
      selling_plan: isSubscribing ? sellingPlanId : null,
      sections: sectionsToBundle
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((parsedState) => {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
    })
    .catch((error) => {
      console.log(error);
    });
  });
});
